import { css } from '@emotion/css';
import grabBoxImg from '../../../assets/grab_lmiit_card.png';
import verfiyBoxImg from '../../../assets/data_bg.png';

export const photoSm = css`
  width: 25px;
  border-radius: 50%;
`;

export const grabBox = css`
  margin: auto;
  width: 328px;
  height: 180px;
  background-image: url(${grabBoxImg});
  background-repeat: no-repeat;
  background-position: center;
`;

export const grabName = css`
  padding: 16px 2px 0px 20px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: 0.16px;
  text-align: left;
  color: #ffffff;
`;

export const grabLoan = css`
  padding: 73px 2px 0px 20px;
  opacity: 0.85;
  font-family: Nunito;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.33;
  letter-spacing: 0.12px;
  text-align: left;
  color: #ffffff;
`;

export const grabLoanAmt = css`
  padding: 1px 2px 0px 20px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.94;
  letter-spacing: 0.32px;
  text-align: left;
  color: #ffffff;
`;

export const loanBox = css`
  margin: auto;
  width: 328px;
  background-position: center;
`;
export const loanTxt1 = css`
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: #009ad6;
`;

export const loanTxt2 = css`
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #858585;
  padding-left: 20px;
`;
export const verifyBox = css`
  margin: auto;
  width: 328px;
  background-image: url(${verfiyBoxImg});
  background-repeat: no-repeat;
  background-position: center;
`;
export const verifyHead = css`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  padding: 40px 2px 0px 20px;
`;
export const verifyContent = css`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  padding: 10px 10px 0px 20px;
`;

export const verifyBox1MuiTableCellRoot = css`
  border-bottom: 0px !important;
`;

export const skipButton = css`
  font-size: 10px !important;
  font-weight: 600 !important;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff !important;
  text-transform: capitalize !important;
  font-family: Nunito !important;
  padding: 5px 5px 5px 5px !important;
`;

export const verifySkip = css`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  font-family: Nunito !important;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
`;

export const privyDoneTitle = css`
  font-size: 14px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff !important;
  font-family: Nunito !important;
  padding-right: 20px !important;
`;

export const privyDoneContent = css`
  font-size: 10px !important;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff !important;
  font-family: Nunito !important;
  padding: 10px 20px 15px 0px !important;
`;

export const centerAlignHomeDiv = css`
  margin: auto;
  width: 100%;
  padding: 70px 15px;
`;

export const centerAlignOfferDiv = css`
  margin: auto;
  width: 100%;
  padding: 15px;

  @media screen and (min-width: 600px) {
    width: 70%;
  }
`;

export const infoCardBox = css`
  margin: auto;
  width: 328px;
  background-repeat: no-repeat;
  background-position: center;
  display: grid !important;
  background-size: cover;
  border-radius: 4px;
`;

export const infoCardBoxMuiTableCellRoot = css`
  border-bottom: 0px !important;
`;

export const infoCardHead1 = css`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  padding: 20px 20px 10px 20px;
`;

export const infoCardContent1 = css`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  padding: 0px 20px 20px 20px;
`;

export const infoCardHead2 = css`
  font-size: 14px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff !important;
  font-family: Nunito !important;
  padding-right: 20px !important;
`;

export const infoCardContent2 = css`
  font-size: 10px !important;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff !important;
  font-family: Nunito !important;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
`;

export const failoverAcceptedHeading = css`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #00acf0;
`;

export const failoverAcceptedContent = css`
  opacity: 0.85;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
`;

export const centerAlignPhotoDiv = css`
  margin: auto;
  width: 100%;

  @media screen and (min-width: 600px) {
    width: 60%;
  }
`;

export const photoUploadHeader = css`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
`;

export const photoUploadContent = css`
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: #00acf0;
  font-family: Nunito;
`;

export const photoUploadLabel = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #5e5e5e;
  font-family: Nunito;
`;

export const photoUploadLabel1 = css`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  font-family: Nunito;
`;

export const photoUploadLabel2 = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #5e5e5e;
  font-family: Nunito;
`;

export const photoUploadFooter = css`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 9px;
  font-family: Nunito;
`;

export const loanButton = css`
  font-family: Nunito !important;
  text-transform: none !important;
`;

export const activeAccountDialog = css`
  text-align: center;
`;

export const activeAccountContent = css`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
  padding-bottom: 20px;
`;

export const buttonLabel = css`
  .activateAccountDialog,
  .cngPh {
    text-transform: none !important;
  }
`;

export const succeesPinHeading = css`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #00acf0;
`;

export const bankConfirmHead = css`
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
`;

export const paymentDialogTxtMuiButtonOutlinedPrimary = css`
  color: #00acf0;
  border: 1px solid #00acf0;
`;

export const commonMsg = css`
  white-space: pre-wrap;
`;
